import React, { useState } from "react";
import "../../css/entry.css";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient.js"
import TokenService from "../../service/TokenService";
import dayjs from "dayjs";

import EncryptService from "../../service/EncryptionService";

import CustomTextField from "../../CustomComponant/CustomTextField ";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import NumericTextField from "../../CustomComponant/NeumericTextField";
import CustomDropdownMenu from "../../CustomComponant/DropDownMenu";

import {  Button } from "@mui/material";

function EditBill() {
  const navigate = useNavigate();
  const [poNumber, setpoNumber] = useState("");
  const [poValue, setpoValue] = useState(0);
  const [poQuantity, setpoQuantity] = useState(0);
  const [poDate, setpoDate] = useState(null);
 const [gemchecked, setgemChecked] = useState(false); // Default is false
 const [gemDate, setGemDate] = useState(null);
  const [billDate, setBillDate] = useState(null);
  const [billQuantity, setbillQuantity] = useState(0);
  const [billValue, setbillValue] = useState(0);
  const [reason, setReason] = useState("");
  const [BillReceiptDate, setBillReceiptDate] = useState(null);
  const [NodalBillReceiptDate, setNodalBillReceiptDate] = useState(null);
  const today = dayjs();

  const handleChange = (event) => {
    const inputValue = event.target.value.toUpperCase();
    // Remove any non-alphanumeric characters
    const alphanumericValue = inputValue.replace(/[^a-zA-Z0-9]/g, "");
    setpoNumber(alphanumericValue);
  };




  const [billNumber, setbillNumber] = useState();
  const [oldbillNumber, setoldbillNumber] = useState();


  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});
  const [selectedOption, setSelectedOption] = useState("");
  const [showRemark, setShowRemark] = useState(true);

   
  const handleQuantityChange = (value) => {
    setbillQuantity(value);
    // Update errors as needed; example here:
    setErrors({
      qty:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };

  const handleValueChange = (value) => {
    setbillValue(value);
    // Update errors as needed; example here:
    setErrors({
      val:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };








 const resetData = async () => {
  setgemChecked(null);
  setGemDate(null);
   setpoDate(null);
   setpoNumber("");
   setBillDate(null);
   setBillReceiptDate(null);
   setbillValue(0);
   setbillNumber("");
   setbillQuantity(0);
   setSelectedOption(0);
   setReason(null);
  setpoQuantity(0);
  setpoValue(0);
setoldbillNumber("");





  };






  const handleOptionChange = (event) => {
    const selvalue = event.target.value;
    setSelectedOption(event.target.value);

    // alert(selvalue);
    if (selvalue === "0") {
      setShowRemark(true);
      setReason("");
    } else {
      setShowRemark(false);
    }
    setErrors({ selerr: "" });
  };

  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));

  //console.log(indentId);

  const UpdateBillData = async (e) => {

    e.preventDefault();
    let formErrors = {};
   
    if (!billDate) {formErrors.errBillDate = "Invalid Bill Date";}
    if (!BillReceiptDate) {formErrors.errreceiptDate = "Invalid Bill Receipt Date";}
   // if (!NodalBillReceiptDate) {formErrors.errnodalDate = "Invalid Nodal Push date Date";}

    if (!billNumber || billNumber.length === 0)
      formErrors.errBill = "Invalid Bill Number";

    if (parseFloat(billQuantity) > parseFloat(poQuantity))
      formErrors.qty = "Qty should be less or equel then PO Qty";

    if (parseFloat(billValue) > parseFloat(poValue))
      formErrors.val = "Value should be less or equel then PO Qty";

    if (!billQuantity || parseFloat(billQuantity) <= 0)
      formErrors.qty = "Qty should be more then zero";

    if (!billValue || parseFloat(billValue) <= 0)
      formErrors.val = "Value should be more then zero";

    if (selectedOption === "1") {
      if (reason.length === 0)
        formErrors.reasonerr = "Remark Should not be Blank";
    }

    if (selectedOption === "0") {
      setReason(" ");
    }

    if (selectedOption.length === 0) {
      formErrors.selerr = "Bill Receipt Type Not Selected";
    }

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const BillRecdt = new Date(BillReceiptDate);
      const BillReceiptDate1 =
        BillRecdt.getFullYear() +
        "/" +
        parseInt(BillRecdt.getMonth() + 1) +
        "/" +
        BillRecdt.getDate();

      const billdt = new Date(billDate);
      const billDate1 =
        billdt.getFullYear() +
        "/" +
        parseInt(billdt.getMonth() + 1) +
        "/" +
        billdt.getDate();

        const nodaldt = new Date(NodalBillReceiptDate);
        const nodaldt1 =
        nodaldt.getFullYear() +
          "/" +
          parseInt(nodaldt.getMonth() + 1) +
          "/" +
          nodaldt.getDate();
  

       

      apiClient.post("/billdataupdate", {

        newbillnumber:billNumber,	
        billdate:billDate1,	
        billitemQty:billQuantity,	
        billitemValue:billValue,	
        paymenttype:selectedOption,	
        remark:reason,	
        billreceiptdate:BillReceiptDate1,	
        ponumber:poNumber,		
        oldbillnumber:oldbillNumber,
        uname,
        ip,	


        
        })
        .then(function (response) {
          console.log(response.data);
          resetData();
        
        })
        .catch(function (error) {
          if (error.response.data && error.response.data.code==='ER_DUP_ENTRY') {
          alert("Duplicate Bill Number for this PO Not Allowed");
       }
     });
    }
  };

  

 
    const getdata = async (e) => {
    apiClient.post("/partPaymentList_by_PONumber_Billnumber", {
      ponumber: poNumber,
      oldbillnumber:oldbillNumber,
      })
      .then(function (response) {
       
        setgemChecked(response.data[0].gemtype);
        setGemDate(response.data[0].gemdate);
         setpoDate(response.data[0].PODate);
         setBillDate(dayjs(response.data[0].billdate));
         setBillReceiptDate(dayjs(response.data[0].billreceiptdate));
         setbillValue(response.data[0].billitemValue);
         setbillNumber(response.data[0].billnumber);
         setbillQuantity(response.data[0].billitemquantity);
         setSelectedOption(response.data[0].paymenttype);
         setReason(response.data[0].remark);
        setpoQuantity(response.data[0].POQty);
        setpoValue(response.data[0].POValue);

      })
      .catch(function (error) {
  console.error("API Error:", error); // log full error for debugging
  const errorMsg = error?.response?.data?.message || error.message || "Unknown error occurred";
  //setError(errorMsg);
  alert("Error fetching data: " + errorMsg);
  resetData(); // Reset form fields on error
});
  };


  const menuoptions = [
    { value: "0", label: "Full Payment" },
    { value: "1", label: "Partial Payment" },
    { value: "2", label: "Final Payment of Partial Paid" },
  ];



  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };

 return (
  <>
    <style>{`
      .edit-bill-page {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        padding: 12px;
        background: #f4f8fc;
        overflow-x: hidden;
      }

      .edit-bill-card {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        margin: 0 auto;
        background: #ffffff;
        border: 1px solid #dbe7f3;
        border-radius: 16px;
        box-shadow: 0 6px 22px rgba(13, 71, 161, 0.10);
        overflow: hidden;
      }

      .edit-bill-header {
        width: 100%;
        box-sizing: border-box;
        padding: 15px 20px;
        display: flex;
        align-items: center;
        gap: 10px;
        color: #ffffff;
        font-size: 18px;
        font-weight: 700;
        background: linear-gradient(
          135deg,
          #0d47a1 0%,
          #1565c0 50%,
          #1976d2 100%
        );
      }

      .edit-bill-header::before {
        content: "🧾";
        font-size: 20px;
      }

      .edit-bill-content {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        padding: 20px;
      }

      .edit-bill-section {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        padding: 16px;
        margin-bottom: 16px;
        background: #fbfdff;
        border: 1px solid #e0eaf5;
        border-radius: 12px;
      }

      .edit-bill-section-title {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 16px;
        padding-bottom: 10px;
        border-bottom: 1px solid #dce8f5;
        color: #0d47a1;
        font-size: 15px;
        font-weight: 700;
      }

      .edit-bill-section-title::before {
        content: "";
        width: 4px;
        height: 20px;
        border-radius: 3px;
        background: linear-gradient(
          180deg,
          #0d47a1,
          #1976d2
        );
      }

      .edit-bill-search-grid {
        width: 100%;
        min-width: 0;
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
        gap: 14px;
        align-items: center;
      }

      .edit-bill-grid {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 16px;
      }

      .edit-bill-field {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
      }

      .edit-bill-field .MuiFormControl-root {
        width: 100%;
        max-width: 100%;
      }

      .edit-bill-field .MuiInputBase-root {
        background: #ffffff;
      }

      .edit-bill-field .MuiOutlinedInput-root:hover fieldset {
        border-color: #1976d2;
      }

      .edit-bill-field .MuiOutlinedInput-root.Mui-focused fieldset {
        border-color: #1565c0;
        border-width: 2px;
      }

      .edit-bill-search-button {
        min-width: 110px !important;
        min-height: 42px !important;
        border-radius: 8px !important;
        text-transform: none !important;
        font-weight: 700 !important;
        background: linear-gradient(
          135deg,
          #0d47a1,
          #1976d2
        ) !important;
        box-shadow: 0 3px 8px rgba(13, 71, 161, 0.20) !important;
      }

      .edit-bill-search-button:hover {
        box-shadow: 0 5px 12px rgba(13, 71, 161, 0.28) !important;
      }

      .edit-bill-actions {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        display: flex;
        justify-content: flex-end;
        margin-top: 4px;
      }

      .edit-bill-update-button {
        width: 180px;
        max-width: 100%;
        min-height: 44px;
        padding: 10px 20px;
        border: none;
        border-radius: 9px;
        color: #ffffff;
        background: linear-gradient(
          135deg,
          #0d47a1,
          #1976d2
        );
        font-size: 14px;
        font-weight: 700;
        cursor: pointer;
        box-shadow: 0 4px 10px rgba(13, 71, 161, 0.20);
        transition: all 0.2s ease;
      }

      .edit-bill-update-button:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 6px 14px rgba(13, 71, 161, 0.28);
      }

      .edit-bill-update-button:disabled {
        opacity: 0.55;
        cursor: not-allowed;
        box-shadow: none;
      }

      .edit-bill-readonly .MuiInputBase-root {
        background: #f1f5f9;
      }

      .edit-bill-info {
        padding: 9px 12px;
        border-radius: 7px;
        background: #eaf3ff;
        border: 1px solid #cfe2f8;
        color: #0d47a1;
        font-size: 12px;
        font-weight: 600;
      }

      @media (max-width: 900px) {
        .edit-bill-search-grid {
          grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        }

        .edit-bill-search-button {
          width: 100%;
        }

        .edit-bill-search-action {
          grid-column: 1 / -1;
        }
      }

      @media (max-width: 650px) {
        .edit-bill-page {
          padding: 8px;
        }

        .edit-bill-card {
          border-radius: 12px;
        }

        .edit-bill-header {
          padding: 13px 15px;
          font-size: 16px;
        }

        .edit-bill-content {
          padding: 12px;
        }

        .edit-bill-section {
          padding: 12px;
          margin-bottom: 13px;
        }

        .edit-bill-search-grid,
        .edit-bill-grid {
          grid-template-columns: minmax(0, 1fr);
          gap: 13px;
        }

        .edit-bill-search-action {
          grid-column: auto;
        }

        .edit-bill-search-button {
          width: 100%;
        }

        .edit-bill-actions {
          display: block;
        }

        .edit-bill-update-button {
          width: 100%;
        }
      }

      @media (max-width: 380px) {
        .edit-bill-page {
          padding: 5px;
        }

        .edit-bill-content {
          padding: 9px;
        }

        .edit-bill-section {
          padding: 10px;
        }

        .edit-bill-header {
          font-size: 15px;
        }
      }
    `}</style>

    <div className="edit-bill-page">
      <div className="edit-bill-card">

        {/* Header */}
        <div className="edit-bill-header">
          Edit Bill / Invoice
        </div>

        <div className="edit-bill-content">

          {/* Search Section */}
          <div className="edit-bill-section">
            <div className="edit-bill-section-title">
              Search Bill / Invoice
            </div>

            <div className="edit-bill-search-grid">

              <div className="edit-bill-field">
                <CustomTextField
                  label="PO Number (Max 20 Character)*"
                  value={poNumber || ""}
                  onChange={handleChange}
                  placeholder="PO Number (Max 20 Character)*"
                  maxLength={20}
                />
              </div>

              <div className="edit-bill-field">
                <CustomTextField
                  label="Old Bill/Invoice Number"
                  value={oldbillNumber || ""}
                  onChange={(e) => {
                    setoldbillNumber(e.target.value);
                  }}
                  placeholder="Old Bill/Invoice Number"
                  maxLength={50}
                />
              </div>

              <div className="edit-bill-search-action">
                <Button
                  variant="contained"
                  startIcon={<SearchIcon />}
                  onClick={getdata}
                  disabled={!(oldbillNumber && poNumber)}
                  className="edit-bill-search-button"
                >
                  Search
                </Button>
              </div>

            </div>
          </div>

          {/* PO Information */}
          <div className="edit-bill-section">
            <div className="edit-bill-section-title">
              PO Information
            </div>

            <div className="edit-bill-grid">

              <div className="edit-bill-field edit-bill-readonly">
                <CustomTextField
                  label="PO Date"
                  value={
                    poDate
                      ? dayjs(poDate).format("DD-MMM-YYYY")
                      : ""
                  }
                  disabled={true}
                />
              </div>

              <div className="edit-bill-field edit-bill-readonly">
                <CustomTextField
                  label="GeM Date"
                  value={
                    gemDate
                      ? dayjs(gemDate).format("DD-MMM-YYYY")
                      : ""
                  }
                  disabled={true}
                />
              </div>

            </div>
          </div>

          {/* Bill Information */}
          <div className="edit-bill-section">
            <div className="edit-bill-section-title">
              Bill / Invoice Information
            </div>

            <div className="edit-bill-grid">

              <div className="edit-bill-field">
                <DatePickerComponent
                  label="Bill/Invoice Date"
                  id="billdate"
                  value={billDate}
                  onChange={(newDate) =>
                    handleDateChange(newDate, setBillDate)
                  }
                  error={errors.errBillDate}
                  maxDate={today}
                  minDate={
                    gemchecked
                      ? dayjs(gemDate)
                      : dayjs(poDate)
                  }
                />
              </div>

              <div className="edit-bill-field">
                <CustomTextField
                  label="New Bill/Invoice Number"
                  value={billNumber || ""}
                  onChange={(e) => {
                    setbillNumber(e.target.value);
                  }}
                  placeholder="New Bill/Invoice Number"
                  maxLength={50}
                  error={!!errors.errBill}
                  helperText={errors.errBill}
                />
              </div>

              <div className="edit-bill-field">
                <NumericTextField
                  id="ItemQuantity"
                  label="Quantity"
                  title="Quantity"
                  error={errors.qty}
                  value={billQuantity}
                  onChange={handleQuantityChange}
                />
              </div>

              <div className="edit-bill-field">
                <NumericTextField
                  id="ItemValue"
                  label="Item Value"
                  title="Item Value"
                  error={errors.val}
                  value={billValue}
                  onChange={handleValueChange}
                />
              </div>

              <div className="edit-bill-field">
                <DatePickerComponent
                  label="Bill/Invoice Receiving Date"
                  id="BillReceiptDate"
                  value={BillReceiptDate}
                  onChange={(newDate) =>
                    handleDateChange(
                      newDate,
                      setBillReceiptDate
                    )
                  }
                  error={errors.errreceiptDate}
                  maxDate={today}
                />
              </div>

              <div className="edit-bill-field">
                <CustomDropdownMenu
                  options={menuoptions}
                  selectedOption={selectedOption}
                  handleOptionChange={handleOptionChange}
                  error={errors.selerr}
                  menulabel="Select Payment Option"
                />
              </div>

            </div>
          </div>

          {/* Partial Payment Remark */}
          {!showRemark && (
            <div className="edit-bill-section">
              <div className="edit-bill-section-title">
                Partial Payment Details
              </div>

              <div className="edit-bill-field">
                <CustomTextField
                  label="Reason Why → Partial Payment Done"
                  value={reason || ""}
                  onChange={(e) => {
                    setReason(e.target.value);
                  }}
                  placeholder="Reason"
                  maxLength={100}
                  error={!!errors.reasonerr}
                  helperText={errors.reasonerr}
                />
              </div>
            </div>
          )}

          {/* Update */}
          <div className="edit-bill-actions">
            <button
              className="edit-bill-update-button"
              type="button"
              onClick={UpdateBillData}
              disabled={!billNumber}
              title="Click for Data Update"
            >
              ✓ Update Data
            </button>
          </div>

        </div>
      </div>
    </div>
  </>
);
}


export default EditBill